import styled from "styled-components"

interface ContainerBlock {
    bg?: string
}

export const ContainerBlock = styled.div`
    background-color: ${(p: ContainerBlock) => p.bg};
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 24px;
    border: 0;
    padding: 0; 
    display: flex;
    flex-direction: column;
    align-items: center;
    Justify-items: center;
`

export const ModalHeader = styled.div`
    width: 100%;
    border-bottom: 3px #00000029 solid;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: MontserratRegular;
    `

interface ModalTitle {
    textColor?: string
}

export const ModalTitle = styled.div`
    font-size: clamp(1.5rem, 2vw, 1.5rem);
    color: ${(p: ModalTitle) => p.textColor ? p.textColor : "var(--color-text)"};
    margin-left: 10px;
    font-family: MontserratRegular;
    `

export const ModalContent = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem 2.5rem 1rem 2.5rem;
`